import { render, staticRenderFns } from "./default.vue?vue&type=template&id=b8af3a6e&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&id=b8af3a6e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardsCreateOrder: require('/opt/buildhome/repo/components/cards/CreateOrder.vue').default,CardsCreateUsage: require('/opt/buildhome/repo/components/cards/CreateUsage.vue').default})
